import { useRef } from 'react';
import { Checkbox, Col, Input, Row } from 'antd';
import { useDispatch } from 'react-redux';

const FilterComponent = ({ idField, items, onFilter, updateFilters }) => {
  const filterInputRef = useRef(undefined);
  const dispatch = useDispatch();

  const isIndeterminate = () => {
    const enabledCount = _.filter(items, (item) => item.enabled).length;
    return enabledCount !== _.size(items) && enabledCount !== 0;
  };

  const onCheck = ({ target: { checked }}) => {
    const updatedItems = _.keyBy(_.map(items, (item) => ({ ...item, enabled: checked })), idField);
    dispatch(updateFilters(updatedItems));
  };

  return (
    <Row type="flex" gutter={8} align="middle" style={{ marginBottom: '8px', paddingBottom: '8px' }}>
      <Col>
        <Checkbox
          onChange={onCheck}
          checked={!_.find(items, (item) => !item.enabled)}
          indeterminate={isIndeterminate()}
        />
      </Col>
      <Col style={{ flex: 'auto' }}>
        <Input
          size="small"
          ref={filterInputRef}
          tabIndex={2}
          onChange={({ target: { value }}) => onFilter(value)}
          placeholder="Filter"
        />
      </Col>
    </Row>
  );
};

export default FilterComponent;
